import { render } from "./Dashboard.vue?vue&type=template&id=c721d84c&scoped=true&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=c721d84c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c721d84c"]])

export default __exports__